import { Box, Button, styled, Typography } from "@mui/material";

export const FallbackContainer = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
    gap: "16px",
    marginTop: "8px",
});
export const FallbackText = styled(Typography)({
    fontSize: "14px",
    color: "var(--community-color-primary-text)",
    margin: "0 auto",
});

export const FallbackButton = styled(Button)({
    backgroundColor: "transparent",
    boxShadow: "none",
    color: "var(--community-color-light-steal-blue)",
    border: "1px solid var(--community-color-light-steal-blue)",
    width: "fit-content",
    margin: "0 auto",
    borderRadius: "90px",
    padding: "0 16px",
    height: "36px",
    span: {
        fontWeight: "500",
        fontSize: "14px",
        textTransform: "capitalize",
    },
});
